import { Redirect, Route, Switch } from "react-router-dom";

import Collaborator from "../module/Collaborator/components/list";
import FormCollaborator from "../module/Collaborator/components/form";
import FormProjects from "../module/Project/components/form/form-projects.components";

import FormTimeSheet from "../module/TimeSheet/web/form";
import useAppData from "../hook/useAppData";
import Projects from "../module/Project";
import PageNotFound from "../module/NotFound";
import ParametersComponent from "../module/Parameters/components/form";
import RoutineAppointment from "../module/RoutineAppointment";
import ApprovalHours from "../module/ApprovalHours";
import Technologies from "../module/Technologies";
import ListJobPosition from "../module/JobsRoles/components/list";
import { HistoryPage } from "../module/History";
import Home from "../module/HomePage";
import { FormInventoryEletronics } from "../module/InventoryManagement/components/electronics/Form";
import { ListInventoryEletronics } from "../module/InventoryManagement/components/electronics/List";
import { FormInventoryImmobilized } from "../module/InventoryManagement/components/immobilized/Form";
import { ListInventoryImmobilized } from "../module/InventoryManagement/components/immobilized/List";
import { FormClientPage } from "../module/Client/components/form";
import { ListClientPage } from "../module/Client/components/list";
import ListProjectByClient from "../module/Client/components/list-project";
import ListProjectDetails from "../module/Project/components/listDetails";
import ListHoursManagement from "../module/hoursManagement/components/listGeral";
import ListDetailsHoursManagement from "../module/hoursManagement/components/listDetails";
import Dashboard from "../module/Dashboard";
import ListCostCenters from "../module/CostCenter/components/list";
import ListSeniorities from "../module/Seniority/components/list";
import RoleInProject from "../module/RoleInProject";
import { Corporation } from "../module/Corporation";
import FormProfile from "../module/Profile/components/form";
import { ACCESS } from "../module/Profile/constants";
import { Profiles } from "../module/Profile";
import { ListTaxes } from "../module/Taxes/components/list";
import FormTax from "../module/Taxes/components/form";
import { TimeSheetComponent, TimeSheetMobile } from "../module/TimeSheet";
import { TimeSheetHistoryMobile } from "../module/TimeSheet/mobile/list";
import { FormTimeSheetMobile } from "../module/TimeSheet/mobile/form";
import { UserInvoice } from "../module/Invoice";
import { JobSettings } from "../module/JobSettings";
import { Payments } from "../module/Payments";
import { PaymentsStatus } from "../module/Payments/PaymentsStatus";
import { Tutorial } from "../module/Tutorial";

export default function Routes(params: any) {
  const { accessIds } = useAppData();
  const accessRoutineAppointment =
    accessIds?.includes(ACCESS.ROUTINE_APPOINTMENT_read) || accessIds?.includes(ACCESS.ROUTINE_APPOINTMENT_consolidate);

  const updateUser = accessIds?.includes(ACCESS.USERS_DATA_all) || accessIds?.includes(ACCESS.USERS_SELF_REGISTRATION_read);

  const TimesheetIsMobile = () => {
    return window.screen.width <= 425 ? TimeSheetMobile : TimeSheetComponent;
  };

  const homeIsMobile = () => {
    if (window.screen.width > 425) return accessIds?.includes(ACCESS.HOMEPAGE_graphic) ? Dashboard : Home;
    if (accessIds?.includes(ACCESS.TIMESHEET_all)) return TimesheetIsMobile();
    return Home;
  };

  const timesheetFormIsMobile = () => {
    if (accessIds?.includes(ACCESS.TIMESHEET_all)) {
      return window.screen.width <= 425 ? FormTimeSheetMobile : FormTimeSheet;
    }
    return RedirectADM;
  };

  return (
    <>
      <Switch>
        <Route exact path="/" component={RedirectADM} />
        <Route exact path="/collaborator" component={accessIds?.includes(ACCESS.USERS_DATA_all) ? Collaborator : RedirectADM} />
        <Route exact path="/collaborator/form" component={accessIds?.includes(ACCESS.USERS_DATA_all) ? FormCollaborator : RedirectADM} />
        <Route exact path="/collaborator/form/:id" component={updateUser ? FormCollaborator : RedirectADM} />
        <Route exact path="/clients" component={accessIds?.includes(ACCESS.CLIENT_all) ? ListClientPage : RedirectADM} />
        <Route exact path="/clients/form" component={accessIds?.includes(ACCESS.CLIENT_all) ? FormClientPage : RedirectADM} />
        <Route exact path="/clients/form/:id" component={accessIds?.includes(ACCESS.CLIENT_all) ? FormClientPage : RedirectADM} />
        <Route exact path="/client-project/:id" component={accessIds?.includes(ACCESS.CLIENT_all) ? ListProjectByClient : RedirectADM} />
        <Route exact path="/projects" component={accessIds?.includes(ACCESS.PROJECT_read) ? Projects : RedirectADM} />
        <Route exact path="/projects/details/:id" component={accessIds?.includes(ACCESS.PROJECT_read) ? ListProjectDetails : RedirectADM} />
        <Route exact path="/projects/form" component={accessIds?.includes(ACCESS.PROJECT_write) ? FormProjects : RedirectADM} />
        <Route exact path="/projects/form/:id" component={accessIds?.includes(ACCESS.PROJECT_read) ? FormProjects : RedirectADM} />
        <Route exact path="/projects/form/clients/:id" component={accessIds?.includes(ACCESS.PROJECT_write) ? FormProjects : RedirectADM} />
        <Route exact path="/timesheet" component={TimesheetIsMobile()} />
        <Route
          exact
          path="/timesheet/history"
          component={accessIds?.includes(ACCESS.TIMESHEET_all) && window.screen.width <= 425 ? TimeSheetHistoryMobile : RedirectADM}
        />
        <Route exact path="/timesheet/form" component={timesheetFormIsMobile()} />
        <Route exact path="/timesheet/form/:id" component={timesheetFormIsMobile()} />
        <Route exact path="/routine-appointment" component={accessRoutineAppointment ? RoutineAppointment : RedirectADM} />
        <Route exact path="/approve-hours" component={accessIds?.includes(ACCESS.APPROVAL_HOURS_read_approve) ? ApprovalHours : RedirectADM} />
        <Route exact path="/history" component={accessIds?.includes(ACCESS.HISTORY_all) ? HistoryPage : RedirectADM} />
        <Route exact path="/home" component={homeIsMobile()} />

        <Route exact path="/eletronic-inventory" component={accessIds?.includes(ACCESS.ELETRONICS_all) ? ListInventoryEletronics : RedirectADM} />
        <Route
          exact
          path="/eletronic-inventory/form"
          component={accessIds?.includes(ACCESS.ELETRONICS_all) ? FormInventoryEletronics : RedirectADM}
        />
        <Route
          exact
          path="/eletronic-inventory/form/:id"
          component={accessIds?.includes(ACCESS.ELETRONICS_all) ? FormInventoryEletronics : RedirectADM}
        />
        <Route exact path="/immobilized-inventory" component={accessIds?.includes(ACCESS.IMMOBILIZED_all) ? ListInventoryImmobilized : RedirectADM} />
        <Route
          exact
          path="/immobilized-inventory/form"
          component={accessIds?.includes(ACCESS.IMMOBILIZED_all) ? FormInventoryImmobilized : RedirectADM}
        />
        <Route
          exact
          path="/immobilized-inventory/form/:id"
          component={accessIds?.includes(ACCESS.IMMOBILIZED_all) ? FormInventoryImmobilized : RedirectADM}
        />

        <Route exact path="/hours-management" component={accessIds?.includes(ACCESS.HOURS_MANAGEMENT_all) ? ListHoursManagement : RedirectADM} />
        <Route
          exact
          path="/hours-management/:id"
          component={accessIds?.includes(ACCESS.HOURS_MANAGEMENT_all) ? ListDetailsHoursManagement : RedirectADM}
        />
        <Route exact path="/parameters/form" component={accessIds?.includes(ACCESS.SETTINGS_all) ? ParametersComponent : RedirectADM} />
        <Route exact path="/technologies" component={accessIds?.includes(ACCESS.SETTINGS_all) ? Technologies : RedirectADM} />
        <Route exact path="/jobPosition" component={accessIds?.includes(ACCESS.SETTINGS_all) ? ListJobPosition : RedirectADM} />
        <Route exact path="/seniority" component={accessIds?.includes(ACCESS.SETTINGS_all) ? ListSeniorities : RedirectADM} />
        <Route exact path="/cost-center" component={accessIds?.includes(ACCESS.SETTINGS_all) ? ListCostCenters : RedirectADM} />
        <Route exact path="/role-in-project" component={accessIds?.includes(ACCESS.SETTINGS_all) ? RoleInProject : RedirectADM} />
        <Route exact path="/corporation" component={accessIds?.includes(ACCESS.SETTINGS_all) ? Corporation : RedirectADM} />
        <Route exact path="/profile" component={accessIds?.includes(ACCESS.SETTINGS_all) ? Profiles : RedirectADM} />
        <Route exact path="/profile/form" component={accessIds?.includes(ACCESS.SETTINGS_all) ? FormProfile : RedirectADM} />
        <Route exact path="/profile/form/:id" component={accessIds?.includes(ACCESS.SETTINGS_all) ? FormProfile : RedirectADM} />
        <Route exact path="/taxes" component={accessIds?.includes(ACCESS.SETTINGS_all) ? ListTaxes : RedirectADM} />
        <Route exact path="/taxes/simple-form" component={accessIds?.includes(ACCESS.SETTINGS_all) ? FormTax : RedirectADM} />
        <Route exact path="/taxes/presumed-form" component={accessIds?.includes(ACCESS.SETTINGS_all) ? RedirectADM : RedirectADM} />
        <Route exact path="/taxes/simple-form/:id" component={accessIds?.includes(ACCESS.SETTINGS_all) ? FormTax : RedirectADM} />
        <Route exact path="/taxes/presumed-form/:id" component={accessIds?.includes(ACCESS.SETTINGS_all) ? RedirectADM : RedirectADM} />
        <Route exact path="/invoice" component={accessIds?.includes(ACCESS.SELF_INVOICE_all) ? UserInvoice : RedirectADM} />
        <Route exact path="/job-settings" component={accessIds?.includes(ACCESS.SETTINGS_all) ? JobSettings : RedirectADM} />
        <Route exact path="/payments" component={Payments} />
        <Route exact path="/payments-status" component={PaymentsStatus} />
        <Route exact path="/tutorial" component={Tutorial} />
        <Route path="*" component={PageNotFound} />
      </Switch>
    </>
  );

  function RedirectADM() {
    return <Redirect to="/home" />;
  }
}
